import { useReducer } from 'react';

import { DataPayload } from 'types/reduxTypes/ActionTypes';
import { EditAngelInvestorMemberType } from 'types/people/editMemberProfile';
import { SetAngelInvestorFieldType } from 'types/reduxTypes/ActionTypes/PeopleTypes';
import { reducer, initialState } from './reducer';
import {
  setField as setFieldAC,
  setAll as setAllAC,
  setEmiratesId as setEmiratesIdAC,
  setVisa as setVisaAC,
  setShowError as setShowErrorAC,
  setPassport as setPassportAC,
} from './actions';

const useEditAIMemberHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setField = (payload: SetAngelInvestorFieldType) => {
    dispatch(setFieldAC(payload));
  }

  const setShowError = (payload: SetAngelInvestorFieldType) => {
    dispatch(setShowErrorAC(payload));
  }

  const setAll = (payload: DataPayload<EditAngelInvestorMemberType>) => {
    dispatch(setAllAC(payload));
  }

  const setEmiratesId = (payload: DataPayload<string | Blob>) => {
    dispatch(setEmiratesIdAC(payload));
  }

  const setVisa = (payload: DataPayload<string | Blob>) => {
    dispatch(setVisaAC(payload));
  }

  const setPassport = (payload: DataPayload<string | Blob>) => {
    dispatch(setPassportAC(payload));
  }

  return {
    state,
    setAll,
    setField,
    setEmiratesId,
    setVisa,
    setPassport,
    setShowError,
  }
}

export default useEditAIMemberHook;
